import { Injectable } from '@angular/core';

import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

import * as NotificationActions from '@app/notifications/store/actions/notifications.actions';

import { NotificationService } from '@app/notifications/services';
import { ToastService } from '@app/shared/services';

@Injectable()
export class UserEffects {
  getNotificationsInWindow$ = createEffect(() =>
    this.actions$.pipe(
      ofType<NotificationActions.GetWindowNotifications>(
        NotificationActions.NotificationActionTypes.GET_DATA_IN_WINDOW
      ),
      switchMap((action: any) => {
        return this._NotificationsService.getNotifications(action.payload).pipe(
          map((resp) => {
            return new NotificationActions.GetWindowNotificationsSuccess(resp);
          }),
          catchError((error) => {
            return of(
              new NotificationActions.GetWindowNotificationsError(error)
            );
          })
        );
      })
    )
  );

  getNotificationsInContainer$ = createEffect(() =>
    this.actions$.pipe(
      ofType<NotificationActions.GetWindowNotifications>(
        NotificationActions.NotificationActionTypes.GET_DATA_IN_CONTAINER
      ),
      switchMap((action: any) => {
        return this._NotificationsService.getNotifications(action.payload).pipe(
          map((resp) => {
            return new NotificationActions.GetContainerNotificationsSuccess(
              resp
            );
          }),
          catchError((error) => {
            return of(
              new NotificationActions.GetContainerNotificationsError(error)
            );
          })
        );
      })
    )
  );

  createNotification$ = createEffect(() =>
    this.actions$.pipe(
      ofType<NotificationActions.CreateNotification>(
        NotificationActions.NotificationActionTypes.CREATE
      ),
      switchMap((action) => {
        return this._NotificationsService
          .createNotification(action.payload)
          .pipe(
            map((resp) => {
              return new NotificationActions.CreateNotificationSuccess(resp);
            }),
            catchError((error) => {
              this._ToastService.addError(error);
              return of(new NotificationActions.CreateNotificationError(error));
            })
          );
      })
    )
  );

  readAllNotifications$ = createEffect(() =>
    this.actions$.pipe(
      ofType<NotificationActions.ReadAllNotifications>(
        NotificationActions.NotificationActionTypes.READ_ALL
      ),
      switchMap((action) => {
        return this._NotificationsService
          .readAllNotifications(action.payload)
          .pipe(
            map(() => {
              return new NotificationActions.ReadAllNotificationsSuccess(
                action.payload
              );
            }),
            catchError((error) => {
              this._ToastService.addError(error);
              return of(
                new NotificationActions.ReadAllNotificationsSuccess(error)
              );
            })
          );
      })
    )
  );

  readOneNotification$ = createEffect(() =>
    this.actions$.pipe(
      ofType<NotificationActions.ReadOneNotification>(
        NotificationActions.NotificationActionTypes.READ_ONE_NOTIFICATION
      ),
      switchMap((action: any) => {
        return this._NotificationsService
          .readOneNotification(action.payload)
          .pipe(
            map(() => {
              return new NotificationActions.ReadOneNotificationSuccess(
                action.payload
              );
            }),
            catchError((error) => {
              return of(
                new NotificationActions.ReadOneNotificationError(error)
              );
            })
          );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private _NotificationsService: NotificationService,
    private _ToastService: ToastService
  ) {}
}
